<app-form-builder [fieldDetails]="widgetFields" (actionEvents)="actionHandler($event)" #createBarForm></app-form-builder>
